<template>
  <AttrBase :label="label" :disabled="disabled">
    <div
      class="flex items-center relative bg-yellow1-50"
      @click="!disabled && showModal()"
    >
      <div class="hover:opacity-80 cursor-pointer">
        <div
          v-if="src"
          class="w-[24px] h-[24px] rounded-sm border-[#000] border-[1px]"
        >
          <img
            class="object-contain w-full h-full p-[1px] cursor-pointer"
            :src="src"
            alt="序列帧图片"
          />
        </div>
        <div v-else>默认</div>
      </div>
    </div>
  </AttrBase>
</template>
<script lang="ts" setup>
defineProps({
  label: {
    type: String,
    default: undefined
  },
  disabled: {
    type: Boolean,
    default: undefined
  },
  src: {
    type: String,
    default: undefined
  }
});

const emits = defineEmits<{
  (event: 'click'): void;
}>();

const showModal = () => {
  emits('click');
};
</script>

<style lang="less" scoped></style>
